/* ===================================================================
 * Hero Banner Carousel - vanilla, dependency-free
 * Used by sections/hero-banner-carousel.liquid
 * =================================================================== */

(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function HeroBannerCarousel(root) {
    this.root = root;
    this.viewport = root.querySelector('.hbc__viewport');
    this.track = root.querySelector('.hbc__track');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.hbc__slide'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.hbc__dot'));
    this.prevBtn = root.querySelector('.hbc__arrow--prev');
    this.nextBtn = root.querySelector('.hbc__arrow--next');
    this.live = root.querySelector('.hbc__live');

    this.currentIndex = 0;
    this.total = this.slides.length;
    this.autoplayMs = (parseInt(root.dataset.autoplaySeconds, 10) || 6) * 1000;
    this.autoplayEnabled = root.dataset.autoplay === 'true';
    this.timer = null;
    this.touchStartX = 0;
    this.io = null;
    this.isVisible = true;

    if (this.total <= 1) return;
    this.init();
  }

  HeroBannerCarousel.prototype.init = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.prev();
        self.restartAutoplay();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.next();
        self.restartAutoplay();
      });
    }

    this.dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        self.goTo(idx);
        self.restartAutoplay();
      });
    });

    this.viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.prev();
        self.restartAutoplay();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.next();
        self.restartAutoplay();
      }
    });

    this.root.addEventListener('mouseenter', function () { self.stopAutoplay(); });
    this.root.addEventListener('mouseleave', function () { self.startAutoplay(); });

    this.viewport.addEventListener('touchstart', function (e) {
      self.touchStartX = e.touches[0].clientX;
      self.stopAutoplay();
    }, { passive: true });

    this.viewport.addEventListener('touchend', function (e) {
      var diff = self.touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) self.next(); else self.prev();
      }
      self.startAutoplay();
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          self.isVisible = entry.isIntersecting;
          if (entry.isIntersecting) self.startAutoplay();
          else self.stopAutoplay();
        });
      }, { threshold: 0.25 });
      this.io.observe(this.root);
    }

    if (REDUCED_MOTION.addEventListener) {
      REDUCED_MOTION.addEventListener('change', function () {
        if (REDUCED_MOTION.matches) self.stopAutoplay();
        else self.startAutoplay();
      });
    }

    this.update();
    this.startAutoplay();
  };

  HeroBannerCarousel.prototype.goTo = function (index) {
    this.currentIndex = ((index % this.total) + this.total) % this.total;
    this.update();
  };

  HeroBannerCarousel.prototype.next = function () { this.goTo(this.currentIndex + 1); };
  HeroBannerCarousel.prototype.prev = function () { this.goTo(this.currentIndex - 1); };

  HeroBannerCarousel.prototype.update = function () {
    var idx = this.currentIndex;
    this.track.style.transform = 'translateX(-' + (idx * 100) + '%)';

    this.slides.forEach(function (slide, i) {
      var isActive = i === idx;
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      if (isActive) slide.removeAttribute('inert');
      else slide.setAttribute('inert', '');
    });

    this.dots.forEach(function (dot, i) {
      var isActive = i === idx;
      dot.classList.toggle('hbc__dot--active', isActive);
      if (isActive) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });

    if (this.live) {
      var slideName = this.slides[idx].getAttribute('data-slide-name') || ('Slide ' + (idx + 1));
      this.live.textContent = 'Showing ' + slideName + ', ' + (idx + 1) + ' of ' + this.total;
    }
  };

  HeroBannerCarousel.prototype.startAutoplay = function () {
    if (!this.autoplayEnabled) return;
    if (REDUCED_MOTION.matches) return;
    if (!this.isVisible) return;
    this.stopAutoplay();
    var self = this;
    this.timer = setInterval(function () { self.next(); }, this.autoplayMs);
  };

  HeroBannerCarousel.prototype.stopAutoplay = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  HeroBannerCarousel.prototype.restartAutoplay = function () {
    this.stopAutoplay();
    this.startAutoplay();
  };

  function init() {
    var roots = document.querySelectorAll('[data-hbc]');
    for (var i = 0; i < roots.length; i++) {
      new HeroBannerCarousel(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
